import stationBG from '../../station/images/station.svg'
import { KIOSK_MENU_PATH } from '../helpers/kioskConfig'
import heritageExplorerAttractGraphic from '../../station/images/heritage-explorer-attract.svg'
import { catalog } from './catalog'

// Builds the kiosk APPS object (keyed by appId) consumed by the station/kiosk components:
// config.js (navMenu), StationMenu, and CodeEntryAttract. Each app's id +
// localized title/subtitle keys come from its catalog experience; the rest is the
// experience's kiosk presentation block. The station landing (`sta`) is not a discovery
// experience, so it is defined here rather than in the catalog.

const KIOSK_UNDOCK_REDIRECT = '/kioskcodeentry'

const experienceApps = Object.values(catalog).reduce((apps, experience) => {
  if (!experience.kiosk) return apps
  apps[experience.appId] = {
    id: experience.appId,
    keyCodeUndockRedirect: KIOSK_UNDOCK_REDIRECT,
    title: experience.titleKey,
    subtitle: experience.descriptionKey,
    ...experience.kiosk,
  }
  return apps
}, {})

const stationLanding = {
  id: 'sta',
  redirect: KIOSK_MENU_PATH,
  unauthRedirect: KIOSK_MENU_PATH,
  keyCodeUndockRedirect: KIOSK_UNDOCK_REDIRECT,
  bg: stationBG,
  menuImage: null,
  title: 'station.landingpage.title',
  subtitle: 'station.landingpage.subtitle',
  gradientColor1: '#EEEFC9',
  gradientColor2: '#C6D64E',
  guestModeAllowed: true,
  primaryTextColor: '#023D18',
  secondaryTextColor: '#367419',
  allowChineseSurnameExperience: true,
  codeEntryAttract: {
    background: '#215b66',
    graphic: heritageExplorerAttractGraphic,
    graphicSize: 'min(72vh, 52vw) auto',
  },
}

// The personal video playback station. Defined here rather than in the catalog
// for the same reason `sta` is: it is not a discovery experience a patron picks,
// it is a dedicated station. guestModeAllowed is false on purpose - there is no
// video without a specific patron's onboarding data, so a code is the point.
const personalVideoStation = {
  id: 'pvs',
  redirect: '/personalvideo',
  unauthRedirect: '/personalvideo',
  keyCodeUndockRedirect: KIOSK_UNDOCK_REDIRECT,
  bg: null,
  menuImage: null,
  title: 'personalvideo.station.title',
  subtitle: 'personalvideo.station.subtitle',
  guestModeAllowed: false,
  codeEntryAttract: {
    background: '#1b2f4b',
    graphicSize: 'min(72vh, 52vw) auto',
  },
}

const kioskApps = Object.freeze({ ...experienceApps, sta: stationLanding, pvs: personalVideoStation })

export default kioskApps
